import i18next from '@/translation/i18n';

export function formatDueDate(due_date: string) {
    // m월 d일 형태
    // 특수 케이스: 모레까지, 내일까지, 오늘까지, 어제까지

    const now = new Date();
    const dueDate = new Date(due_date);

    // 날짜 비교를 위해 시간 정보 제거하고 날짜만 추출 (시간은 00:00:00으로 설정)
    const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const dueDateOnly = new Date(
        dueDate.getFullYear(),
        dueDate.getMonth(),
        dueDate.getDate()
    );

    // 일 수 차이 계산 (밀리초를 일로 변환)
    const diffDays =
        (dueDateOnly.getTime() - nowDate.getTime()) / (1000 * 60 * 60 * 24);

    // 날짜 차이에 따른 텍스트 반환
    switch (diffDays) {
        case -1:
            return i18next.t('date_picker.until_yesterday');
        case 0:
            return i18next.t('date_picker.until_today');
        case 1:
            return i18next.t('date_picker.until_tomorrow');
        // case 2:
        //     return '모레까지';
        // return '2일 남음';
        default:
            // if (diffDays < -1) {
            //     return `${Math.abs(diffDays)}일 지남`;
            // } else if (diffDays > 2) {
            //     return `${diffDays}일 남음`;
            // }
            return dueDate
                .toLocaleDateString(i18next.language, {
                    month: 'numeric',
                    day: 'numeric',
                    formatMatcher: 'basic',
                })
                .replace('.', '/')
                .replace('.', '')
                .replace(/\s/g, '');
        //  + '까지'
    }
}
